import { useState } from 'react';

export default function useAutomationEdit() {
    const [isEdit, setIsEdit] = useState(false);

    return {
        isEdit,
        setIsEdit
    };
}
